<template>
	<div class="notificacioncontactoFormHeader puiformheader">
	</div>
</template>

<script>
import { PuiFormHeaderMixin } from '@Pui9Components';

export default {
	name: 'notificacioncontacto-form-header',
	mixins: [PuiFormHeaderMixin],
	data() {
		return {
			modelName: 'notificacioncontacto'
		};
	},
	computed: {
	}
}
</script>
